import PropTypes from "prop-types";
import styles from "../../styles/ChatButton.module.css";
import NonoImage from "../../assets/Nono.png"; // Image du robot

export default function ChatButton({ toggleChat, isChatOpen = false }) {
  if (isChatOpen) return null; // Cache le bouton quand le chat est ouvert

  return (
    <div className={styles.container}>
      <div className={styles.chatButtonContainer}>
        <button
          onClick={toggleChat}
          onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && toggleChat()}
          className={styles.chatButton}
          aria-label="Ouvrir le chat"
        >
          <img
            src={NonoImage}
            alt="Ouvrir le chat"
            className={styles.chatIcon}
          />
          <div className={styles.tooltip}>
            Je suis votre assistant, Nono le petit robot !
          </div>
        </button>
      </div>
    </div>
  );
}

ChatButton.propTypes = {
  toggleChat: PropTypes.func.isRequired,
  isChatOpen: PropTypes.bool,
};